import React from 'react';
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl";
import Document from "./Document";

class Documents extends React.Component {

  componentDidMount(){
    const {uuid, connectedUserId} = this.props;
    if (uuid) {
      this.props.dispatchFetchJourneyDocuments({uuid, connectedUserId});
    }
  }

  onDelete = (attachment) => {
    const {uuid} = this.props;
    const {key} = attachment;
    this.props.dispatchDeleteJourneyDocuments({uuid, key});
  };

  renderAllItems = () => {
    const {intervention: {documents = {}}, canWrite} = this.props;
    const {attachments = []} = documents;

    const items = [];
    attachments.forEach(doc =>
      items.push(
        <li key={doc.key}>
          <Document document={doc} onDelete={this.onDelete} canWrite={canWrite}/>
        </li>
      )
    );
    return items;
  };

  render() {
    const {intl:{formatMessage}, saveJourneyDocuments: {error = {}}} = this.props;
    const errors = error.content;

    return (
      <ul className="list">
        {this.renderAllItems()}

        {errors && errors.document &&
          <div className='txt-error'>
            {formatMessage({id: errors.document.message}, {value: errors.document.args[0]})}
          </div>
        }
      </ul>
    );
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention.intervention || {},
  saveJourneyDocuments: state.saveJourneyDocuments,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchJourneyDocuments: (params) => dispatch({type: 'FETCH.JOURNEY_DOCUMENTS.REQUEST', ...params}),
  dispatchDeleteJourneyDocuments: (params) => dispatch({type: 'DELETE.JOURNEY_DOCUMENTS.REQUEST', ...params}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Documents))
